import { Peer, RemoteParticipant, Room, isRemoteParticipant } from "@domain";
import { UniqueEntityId } from "@kernel/ddd";
import { RoomStreamingBloc } from "modules/room/RoomStreamingBloc";
import { SignalingService } from "modules/room/services";

export abstract class BaseStreamingCommand {
  constructor(
    protected readonly bloc: RoomStreamingBloc,
    protected readonly signalingService: SignalingService
  ) {}

  protected checkRoomId(roomId: string): boolean {
    if (roomId.length === 0) return false;
    const room = this.bloc.state.room;
    if (room === null) throw new Error("Room is null");
    return room.id.equals(new UniqueEntityId(roomId));
  }

  protected getRoom(): Room {
    const room = this.bloc.state.room;
    if (room === null) throw new Error("Room is null");
    return room;
  }

  protected getPeer(remoteId: number): Peer | null {
    const room = this.getRoom();
    const remoteParticipant =
      room.remoteParticipants.getParticipantByRemoteId(remoteId);
    if (remoteParticipant === null || !isRemoteParticipant(remoteParticipant))
      return null;
    return (remoteParticipant as RemoteParticipant).peer;
  }

  protected getRoomLocalParticipantDisplayName(): string {
    const room = this.bloc.state.room;
    if (room === null) throw new Error("Room is null");
    if (room.localParticipant === null)
      throw new Error("Local participant is null");
    return room.localParticipant.displayName;
  }

  protected getRoomLocalParticipantRemoteId(): number {
    const room = this.bloc.state.room;
    if (room === null) throw new Error("Room is null");
    if (room.localParticipant === null)
      throw new Error("Local participant is null");
    if (room.localParticipant.remoteId === undefined)
      throw new Error("Local participant remoteId is null");
    return room.localParticipant.remoteId.toValue() as number;
  }

  public abstract execute(e: unknown): void;
}
